interface MaxButtonProps {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}

export function MaxButton({ onClick, disabled, title }: MaxButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className="btn-max-pill disabled:cursor-not-allowed disabled:opacity-40"
    >
      Max
    </button>
  );
}
